var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiSequenceBackground = function SvgAiSequenceBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 622,
    viewBox: "0 0 232 622",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M0 0h232v622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.017 658.968c11.788-8.003 18.292-20.028 17.207-31.796-1.536-16.6-16.65-28.385-36.225-35.38-7.166-2.563-14.69-4.646-21.399-7.816-16.192-7.655-15.438-19.633-22.837-31.31-19.92-31.459-75.5-8.519-109.737-15.892-22.28-4.797-37.88-20.382-38.662-37.295-.056-1.213-.063-2.491-.888-3.548-.571-.727-1.48-1.273-2.403-1.759-14.409-7.625-36.069-4.803-48.921 3.38-14.212 9.054-20.716 22.97-24.563 36.503-3.072 10.8-4.834 22.033-1.783 32.84 8.272 29.334 48.591 47.742 65.403 75.035 3.629 5.895 6.137 12.169 10.442 17.813 10.95 14.349 32.11 22.814 53.22 28.277 26.029 6.736 55.256 9.954 80.932 2.528 16.446-4.755 30.313-13.557 46.871-18.095 11.535-3.176 24.303-7.349 33.343-13.485Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.466 277.413c-3.953 11.203.578 27.599 10.83 36.335 10.245 8.735 26.479 13.376 41.974 12.007 11.175-.99 21.477-4.827 32.25-7.234 10.774-2.408 23.238-3.212 32.596 1.429 4.826 2.389 8.723 6.165 14.409 7.03 5.109.78 10.45-1.129 13.923-4.017 3.467-2.887 5.363-6.622 6.814-10.344 4.087-10.452 5.25-21.529 3.403-32.324-1.296-7.577-4.277-15.304-11.168-20.977-10.456-8.615-27.283-10.663-42.714-12.458-13.867-1.615-27.776-3.44-41.812-3.338-14.036.096-28.396 2.252-40.099 7.997-11.711 5.74-20.371 15.478-20.406 25.894Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    stroke: "#757575",
    strokeWidth: 1.409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.21 0.21"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "m83.445 267.123 178.642-137.792M84.876 278.362l189.873-146.689M90.611 286.185l195.25-150.946M98.68 292.164l199.618-154.41M104.971 299.555 310.84 140.192M112.363 306.069l211.794-164.058M119.691 312.631 334.346 146.31M127.04 319.181l219.778-170.38M134.615 325.551l222.342-172.415M141.295 332.624l224.11-173.808M148.883 338.987l226.056-175.351M156.937 344.979l227.38-176.407M163.723 351.974 383.07 181.93"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "m188.737 345.285 178.648-137.791M190.167 356.518 380.04 209.835M195.903 364.347l195.256-150.952M203.971 370.327l199.618-154.41M210.263 377.711l205.868-159.363M217.654 384.231l211.794-164.058M224.982 390.787l214.655-166.315M232.331 397.343l219.778-170.379"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    stroke: "#757575",
    strokeWidth: 1.409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.21 0.21"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-196.471 661.568.469 486.217M-189.453 667.56 8.643 491.152M-183.548 674.554 7.558 504.51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-160.5 679.099 4.916 532.416M-155.505 686.928 14.597 535.982M-148.479 692.908l173.913-154.41M-142.998 700.292 36.356 540.929M-136.557 706.812 47.961 542.754M-130.173 713.374 56.839 547.053M-123.769 719.924l191.466-170.38M-117.173 726.294 76.533 553.879M-111.346 733.367 83.896 559.553M-104.744 739.73l196.94-175.35M-97.726 745.716 100.37 569.315M-91.814 752.717l191.1-170.044"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M224.447 618.833c-3.537-12.956 0-27.047 9.272-37.733 10.337-11.912 26.952-16.925 41.559-23.955 6.933-3.344 13.684-7.271 18.877-12.488 2.586-2.599 4.706-5.487 6.278-8.621 1.656-3.32 2.72-6.82 3.579-10.339 1.734-7.138 2.741-14.439 6.053-21.223 3.051-6.25 7.652-11.947 13.373-16.642 12.247-10.056 29.489-14.931 46.378-13.334a85.13 85.13 0 0 1 6.419.882c.402.072.578-.444.17-.528-16.517-3.578-35.048.048-48.492 8.837-6.201 4.059-11.436 9.168-15.319 14.95a45.897 45.897 0 0 0-4.805 9.209c-1.346 3.53-2.199 7.175-2.988 10.819-1.599 7.379-2.994 15.015-7.701 21.505-4.376 6.034-10.985 10.609-17.968 14.331-14.36 7.655-31.496 12.122-43.01 23.211-10.252 9.876-15.163 23.594-13.127 36.664.24 1.537.592 3.056 1.029 4.557.056.234.486.132.423-.102Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.107 552.192c0 .51-.486.925-1.085.925-.6 0-1.085-.415-1.085-.925s.486-.924 1.085-.924c.599.006 1.085.414 1.085.924ZM115.592 346.841c.6 0 1.085-.414 1.085-.925 0-.51-.485-.924-1.085-.924-.599 0-1.085.414-1.085.924 0 .511.486.925 1.085.925Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    stroke: "#757575",
    strokeWidth: 1.409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.21 0.21"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "m-53.861 480.087 155.636-137.791M-52.614 491.326l165.416-146.689M-47.618 499.149l170.101-150.946M-40.587 505.129 133.32 350.725M-35.112 512.52 144.25 353.157M-28.671 519.033l184.518-164.051M-22.28 525.596l187.005-166.322M-15.883 532.146l191.473-170.38M-9.287 538.516l193.713-172.415M-3.46 545.594 191.782 371.78M3.15 551.952l196.933-175.351M10.16 557.944l198.103-176.408M16.072 564.938l191.099-170.043"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    stroke: "#757575",
    strokeWidth: 1.409,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.21 0.21"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "m37.866 558.25 155.643-137.792M39.113 569.489 204.536 422.8M44.116 577.312l170.102-150.946M51.14 583.291l173.907-154.409M56.623 590.676l179.353-159.363M63.063 597.196l184.511-164.058M69.447 603.758l187.005-166.321M75.845 610.308l191.472-170.38M82.447 616.678l193.706-172.415M88.267 623.751l195.25-173.814M94.876 630.114l196.941-175.35M101.894 636.1l198.097-176.401M107.806 643.101l191.1-170.044"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.074 399.968c1.95 0 3.53-1.347 3.53-3.008s-1.58-3.008-3.53-3.008c-1.949 0-3.53 1.347-3.53 3.008s1.581 3.008 3.53 3.008Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.074 402.111c3.339 0 6.046-2.306 6.046-5.151 0-2.845-2.707-5.151-6.046-5.151-3.339 0-6.046 2.306-6.046 5.151 0 2.845 2.707 5.151 6.046 5.151Z",
    stroke: "url(#f)",
    strokeWidth: 0.705,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.37 545.192c0 2.011-1.917 3.644-4.278 3.644-2.36 0-4.276-1.633-4.276-3.644s1.916-3.644 4.276-3.644c2.361 0 4.278 1.627 4.278 3.644Z",
    stroke: "url(#g)",
    strokeWidth: 0.705,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.126 413.2c4.654 0 8.427-3.215 8.427-7.181 0-3.965-3.773-7.18-8.427-7.18s-8.427 3.215-8.427 7.18c0 3.966 3.773 7.181 8.427 7.181Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.757 388.681 6.285-6.382",
    stroke: "url(#i)",
    strokeWidth: 0.705,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.688 390.055 9.871-10.02",
    stroke: "#FFC83E",
    strokeWidth: 0.705,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.757 395.357 10.14-10.303",
    stroke: "url(#j)",
    strokeWidth: 0.705,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.542 498.699 8.018-8.153",
    stroke: "url(#k)",
    strokeWidth: 0.705,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.001 500.458 12.606-12.806",
    stroke: "url(#l)",
    strokeWidth: 0.705,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.542 507.224 12.951-13.154",
    stroke: "url(#m)",
    strokeWidth: 0.705,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    strokeWidth: 0.705,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m151.535 356.375-9.414 8.939",
    stroke: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m154.233 358.44-14.782 14.042",
    stroke: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m162.717 355.018-15.192 14.427",
    stroke: "url(#p)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.017 438.247c.6 0 1.085-.414 1.085-.924 0-.511-.485-.925-1.085-.925-.599 0-1.085.414-1.085.925 0 .51.486.924 1.085.924ZM181.777 520.54c0 .511-.486.925-1.085.925s-1.085-.414-1.085-.925c0-.51.486-.924 1.085-.924.599.006 1.085.414 1.085.924ZM15.163 529.9c0 1.105-1.05 2-2.347 2-1.296 0-2.346-.895-2.346-2 0-1.104 1.05-1.999 2.346-1.999 1.297 0 2.347.895 2.347 1.999ZM166.888 528.694c0 1.104-1.05 1.999-2.346 1.999-1.297 0-2.347-.895-2.347-1.999 0-1.105 1.05-2 2.347-2 1.296 0 2.346.895 2.346 2ZM207.059 469.659c0 1.105-1.05 1.999-2.347 1.999-1.296 0-2.346-.894-2.346-1.999s1.05-1.999 2.346-1.999c1.297-.006 2.347.894 2.347 1.999Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-8.611 531.942 6.482 2.245 2.918-8.585-9.4 6.34ZM202.049 430.364l-2.826 12.08-23.027-11.833 25.853-.247Z",
    fill: "#E7750E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.663 450.645-9.745-3.26 1.254 9.834 8.491-6.574Z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.367 363.135c-9.477-4.491-21.216-7.445-31.983-4.815-8.356 2.041-14.663 7.36-19.426 13.352-5.362 6.742-9.139 14.301-13.141 21.668-2.452 4.508-5.123 8.843-8.702 12.794-3.847 4.25-8.427 8.02-13.536 11.154-5.284 3.236-11.105 5.764-17.277 7.511-7.04 1.993-14.353 3.098-21.575 4.491-11.873 2.299-24.465 5.872-32.237 14.385-3.438 3.764-5.482 8.327-5.573 13.112-.099 4.911 1.747 9.75 4.657 13.953 6.603 9.552 18.08 15.015 30.06 18.515 12.823 3.746 26.36 5.53 38.915 9.972 6.271 2.222 12.275 5.133 17.25 9.114 4.932 3.95 8.744 8.759 12.133 13.718 6.39 9.366 11.535 19.579 20.744 27.281 4.249 3.555 9.329 6.43 15.065 7.895 5.763 1.465 11.922 1.465 17.777.403 27.515-5.002 39.762-28.626 50.852-48.024 6.201-10.843 13.078-21.398 23.528-29.713 10.09-8.027 22.132-14.15 31.538-22.82 8.357-7.697 14.642-17.555 13.169-28.343-1.402-10.255-8.892-19.326-18.08-25.744-10.583-7.391-23.675-11.714-36.386-15.688-6.821-2.132-13.726-4.119-20.35-6.676-6.539-2.528-12.824-5.488-19.032-8.55-2.966-1.465-5.911-2.953-8.87-4.43-3.143-1.567-6.406-2.924-9.583-4.431-.247-.12-.473.204-.226.324 3.17 1.501 6.187 3.248 9.315 4.815 2.96 1.477 5.905 2.966 8.871 4.431 6.067 2.996 12.211 5.889 18.588 8.375 12.648 4.935 26.163 8.027 38.775 13.046 11.76 4.677 22.823 10.957 29.883 20.455 3.241 4.359 5.552 9.282 6.187 14.433.662 5.373-.606 10.746-3.298 15.615-5.637 10.201-16.143 17.477-26.367 24.243-5.425 3.591-10.907 7.151-15.861 11.215-4.791 3.927-8.913 8.364-12.493 13.131-7.3 9.72-12.408 20.454-18.672 30.655-6.116 9.954-13.599 19.92-24.605 26.44-10.168 6.022-23.563 9.252-35.619 5.722-11.865-3.477-19.708-12.68-25.683-21.59-6.342-9.462-11.612-19.842-21.286-27.275-9.555-7.336-22.118-10.806-34.308-13.58-12.88-2.93-26.332-5.331-37.69-11.587-10.02-5.518-18.349-15.064-17.954-25.624.395-10.699 10.541-18.222 21.28-22.256 12.887-4.845 27.346-5.271 40.452-9.57 10.978-3.602 20.708-9.81 27.945-17.699 6.426-7 10.047-15.34 14.564-23.264 3.897-6.839 8.315-13.851 15.001-19.026 6.906-5.35 15.77-7.367 24.958-6.274 6.334.75 12.359 2.671 17.96 5.271.381.162.72-.33.346-.51Z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.425,
    d: "M94.03 345.748c-10.836-5.133-24.266-8.507-36.576-5.494-9.547 2.336-16.755 8.418-22.195 15.262-6.137 7.721-10.457 16.372-15.044 24.801-2.811 5.17-5.87 10.129-9.963 14.655-4.404 4.87-9.653 9.198-15.516 12.782-6.052 3.711-12.725 6.605-19.793 8.604-8.053 2.281-16.431 3.542-24.696 5.145-13.578 2.63-27.988 6.712-36.88 16.45-3.925 4.299-6.25 9.51-6.363 14.973-.112 5.614 2.001 11.137 5.32 15.94 7.547 10.921 20.674 17.171 34.371 21.169 14.685 4.287 30.18 6.328 44.553 11.414 7.195 2.545 14.079 5.883 19.779 10.446 5.651 4.521 10.02 10.032 13.902 15.718 7.307 10.716 13.198 22.406 23.739 31.219 4.855 4.065 10.654 7.349 17.214 9.024 6.588 1.675 13.62 1.675 20.314.462 31.475-5.721 45.483-32.756 58.173-54.952 7.102-12.416 14.973-24.507 26.951-34.029 11.556-9.186 25.339-16.198 36.105-26.122 9.555-8.802 16.742-20.071 15.051-32.408-1.607-11.72-10.175-22.094-20.681-29.431-12.105-8.453-27.085-13.4-41.622-17.945-7.814-2.443-15.727-4.719-23.315-7.649-7.483-2.893-14.685-6.28-21.787-9.792-3.396-1.675-6.772-3.38-10.154-5.073-3.593-1.795-7.314-3.374-10.95-5.097-.246-.12-.472.204-.225.324 3.629 1.717 7.103 3.692 10.689 5.482 3.382 1.693 6.764 3.392 10.154 5.073 6.94 3.428 13.972 6.742 21.272 9.588 14.48 5.649 29.953 9.185 44.391 14.931 13.472 5.361 26.141 12.554 34.237 23.432 3.714 4.996 6.363 10.645 7.089 16.553.761 6.166-.698 12.319-3.791 17.909-6.461 11.683-18.489 20.016-30.193 27.767-6.215 4.113-12.486 8.183-18.158 12.836-5.482 4.491-10.196 9.57-14.29 15.021-8.356 11.131-14.205 23.421-21.378 35.098-7.011 11.407-15.579 22.82-28.191 30.289-11.655 6.898-27.015 10.603-40.833 6.55-13.6-3.986-22.597-14.529-29.446-24.747-7.257-10.825-13.29-22.706-24.359-31.214-10.928-8.393-25.302-12.361-39.247-15.531-14.747-3.356-30.157-6.112-43.158-13.269-11.485-6.321-21.032-17.272-20.589-29.382.451-12.265 12.085-20.899 24.394-25.528 14.755-5.547 31.32-6.033 46.329-10.962 12.55-4.119 23.682-11.227 31.961-20.245 7.357-8.015 11.5-17.555 16.665-26.621 4.467-7.834 9.526-15.861 17.185-21.793 7.927-6.136 18.088-8.447 28.636-7.187 7.257.865 14.156 3.062 20.568 6.046.394.174.732-.318.352-.492Z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.031 481.51c8.301-7.642 18.799-13.13 27.861-20.046 7.898-6.028 15.156-13.689 16.932-22.844 1.705-8.838-2.326-17.531-8.829-24.321-7.244-7.565-17.327-12.476-27.713-16.295-11.351-4.172-23.337-7.012-34.47-11.623-11.09-4.599-21.28-10.554-32.208-15.387-8.28-3.663-18.447-5.902-27.656-3.639-7.089 1.741-12.584 6.088-16.798 11.095-4.813 5.716-8.202 12.212-11.633 18.57-1.966 3.65-3.89 7.312-6.476 10.686-2.896 3.771-6.398 7.199-10.365 10.177-4.065 3.056-8.631 5.625-13.521 7.612-5.63 2.288-11.683 3.627-17.75 4.773-11.034 2.084-22.533 3.765-31.8 9.684-3.896 2.492-7.264 5.662-9.23 9.498-1.965 3.831-2.36 8.075-1.367 12.158 2.136 8.753 9.675 15.802 18.574 20.148 20.11 9.829 46.815 8.141 64.092 22.49 8.385 6.965 12.93 16.343 18.778 24.802 5.193 7.516 11.88 14.991 21.653 18.371 9.97 3.452 21.329 1.651 30.51-2.683 9.928-4.683 17.2-12.416 22.907-20.605a121.643 121.643 0 0 0 4.087-6.298c1.339-2.192 2.368-4.485 3.629-6.706.12-.216-.254-.409-.381-.192-1.247 2.203-2.755 4.31-4.079 6.478-1.332 2.179-2.713 4.34-4.193 6.454-2.91 4.16-6.172 8.153-10.034 11.713-7.448 6.868-17.488 12.031-28.614 12.764-5.348.354-10.746-.421-15.558-2.474-4.7-2.005-8.66-5.037-12.014-8.453-7.067-7.198-11.295-15.952-17.045-23.883-2.86-3.944-6.13-7.715-10.181-10.831-4.073-3.134-8.843-5.535-13.846-7.414-10.28-3.867-21.378-5.608-32.102-8.327-10.682-2.708-21.54-6.58-28.707-14.169-6.489-6.874-9.568-16.456-4.326-24.567 5.087-7.871 15.424-12.062 25.176-14.349 11.408-2.678 23.365-3.693 34.005-8.394 8.977-3.962 16.735-9.912 22.315-17.092 4.763-6.124 7.702-13.196 11.563-19.74 3.41-5.77 7.35-11.618 13.155-15.892 6.018-4.431 13.62-6.106 21.463-5.266 11.704 1.249 21.596 7.199 31.539 12.146 5.235 2.606 10.512 5.163 15.973 7.421 5.264 2.179 10.689 3.95 16.185 5.649 20.448 6.346 45.392 13.677 53.086 33.069 1.698 4.274 2.199 8.849 1.205 13.292-1.015 4.527-3.431 8.729-6.539 12.476-6.637 8.021-16.107 13.7-25.014 19.728-4.488 3.038-8.857 6.208-12.711 9.828-.289.276.183.678.472.408Z",
    fill: "url(#t)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -5.309,
    y1: 536.928,
    x2: -94.213,
    y2: 612.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#2F3E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#273132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#1E2422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#1B1F1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 131.048,
    y1: 285.333,
    x2: 289.523,
    y2: 285.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#2F3E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#273132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#1E2422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#1B1F1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 222.53,
    y1: 546.273,
    x2: 376.463,
    y2: 546.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#3F4541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313C40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 168.547,
    y1: 396.962,
    x2: 175.601,
    y2: 396.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 165.674,
    y1: 396.962,
    x2: 178.473,
    y2: 396.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 86.461,
    y1: 545.19,
    x2: 95.718,
    y2: 545.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 180.696,
    y1: 406.022,
    x2: 197.554,
    y2: 406.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 146.211,
    y1: 385.764,
    x2: 153.571,
    y2: 385.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 146.025,
    y1: 390.638,
    x2: 157.601,
    y2: 389.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 163.905,
    y1: 494.97,
    x2: 173.17,
    y2: 494.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 166.149,
    y1: 494.591,
    x2: 180.421,
    y2: 493.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 163.669,
    y1: 501.196,
    x2: 178.318,
    y2: 499.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 146.544,
    y1: 356.395,
    x2: 146.956,
    y2: 365.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 146.405,
    y1: 358.591,
    x2: 147.04,
    y2: 372.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 154.673,
    y1: 355.178,
    x2: 155.325,
    y2: 369.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 168.73,
    y1: 448.435,
    x2: 174.619,
    y2: 455.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F6BE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -57.449,
    y1: 497.981,
    x2: 188.38,
    y2: 392.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#F7CC4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CEAE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#A89348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#887B45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#6C6744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#565742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#454B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#3A4241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#333D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313C40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -92.996,
    y1: 454.15,
    x2: 222.728,
    y2: 454.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#3F4541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313C40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 4.742,
    y1: 393.392,
    x2: 117.779,
    y2: 526.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#333E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#3C4441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#4A4E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#5E5D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#786F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#988746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#BDA249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#E8C14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD24D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h232v622H0z"
  })))));
};
export { SvgAiSequenceBackground as ReactComponent };
export default __webpack_public_path__ + "6023eeb4dd26ab10137d298dcdca2a22.svg";